import React from 'react';
import { X } from 'lucide-react';
import type { OmdPanelTabId } from '../../utils/omdProductView';
import { resolveOmdHeaderInfo } from './omdPanelHelpers';
import type { OmdPanelMaterial } from './types';
import { CopyableMeta } from './shared/CopyableMeta';
import { OmdPanelTabNav } from './OmdPanelTabNav';

const TAB_LABELS: Record<OmdPanelTabId, string> = {
  uebersicht: 'Übersicht',
  technik: 'Technik',
  dokumente: 'Dokumente',
  preise: 'Preise',
};

type OmdPanelHeaderProps = {
  material: OmdPanelMaterial;
  product: unknown | null;
  activeTab: OmdPanelTabId;
  onTabChange: (tab: OmdPanelTabId) => void;
  onClose: () => void;
  showTabs: boolean;
};

export function OmdPanelHeader({
  material,
  product,
  activeTab,
  onTabChange,
  onClose,
  showTabs,
}: OmdPanelHeaderProps) {
  const { title, articleNumber, gtin, brand } = resolveOmdHeaderInfo(material, product);

  return (
    <div className="shrink-0 border-b border-app-border bg-app-surface">
      <div className="px-5 py-4">
        <div className="flex items-start gap-3">
          <div className="flex-1 min-w-0">
            <h2 id="omd-panel-title" className="text-lg font-semibold text-app-text leading-snug">
              {title}
            </h2>

            {(brand || articleNumber || gtin) && (
              <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs">
                {brand && <span className="text-app-text-muted">{brand}</span>}
                {articleNumber && <CopyableMeta label="Art.-Nr." value={articleNumber} />}
                {gtin && gtin !== articleNumber && <CopyableMeta label="GTIN" value={gtin} />}
              </div>
            )}
          </div>

          <button
            type="button"
            onClick={onClose}
            className="shrink-0 inline-flex h-8 w-8 items-center justify-center rounded-lg border border-app-border text-app-text-subtle hover:bg-app-hover hover:text-app-text transition-colors"
            aria-label="Schließen"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>

      {showTabs && (
        <OmdPanelTabNav
          tabs={TAB_LABELS}
          activeTab={activeTab}
          onTabChange={onTabChange}
        />
      )}
    </div>
  );
}

export { TAB_LABELS };
